import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import _ from 'lodash';

import SubmissionItemNav from './SubmissionItemNav';
import { getCurrentSubmissionId, getUserId, getWeekOfDate } from '../selectors';

import { queryGetAllSubmissionsForUserWeekGQL } from '../graphql/allSubmissionsForUserWeek';

const mapStateToProps = (state) => {
  return {
    userId: getUserId(state),
    submissionItemId: getCurrentSubmissionId(state),
    originDate: getWeekOfDate(state),
  };
};


const mapDispatchToProps = {

};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withFormatData = withProps((props) => {
  const { allTimeEntries } = props;

  const allSubmissionIds = allTimeEntries.map((item) => {
    return ({
      id: item.timesheet.document.submission_item.id,
      date: item.date.display,
    });
  });

  const uniqueSubmissionIds = _.uniqBy(allSubmissionIds, 'id');
  return {
    uniqueSubmissionIds,
  };
});

const enhance = compose(
  withRedux,
  queryGetAllSubmissionsForUserWeekGQL,
  withFormatData,
);

export default enhance(SubmissionItemNav);
